// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"32":"styles/app.legacy","284":"styles/admin.legacy","834":"styles/editor.legacy"}[chunkId] + ".css";
};